import type { TaskWhisper } from '@frontend/api-types';
import type { RichWhisperComponentMap } from '@frontend/react-domain';
import { useAnalytics } from '@frontend/web/hooks';
import { useEffect } from 'react';
import { PlainWhisper, type PlainWhisperProps } from './PlainWhisper';
import { WEB_WHISPER_COMPONENTS } from './whisperRegistry';

export type TaskChatWhisperProps = PlainWhisperProps & {
  commentId?: string;
  richWhisperComponents?: RichWhisperComponentMap;
  whisper?: TaskWhisper;
};

export const TaskChatWhisper = ({
  commentId,
  richWhisperComponents = WEB_WHISPER_COMPONENTS,
  whisper,
  ...rest
}: TaskChatWhisperProps) => {
  const { track } = useAnalytics();
  const RichWhisper = whisper ? richWhisperComponents[whisper.type] : undefined;
  const taskId = rest.taskId;

  useEffect(() => {
    if (!whisper || !commentId || !taskId || RichWhisper) return;
    track({
      data: { commentId, source: 'plain', taskId, whisperType: whisper.type },
      event: 'whisperRendered',
      topic: 'whispers',
    });
  }, [commentId, whisper, taskId, RichWhisper, track]);

  return RichWhisper && whisper ? (
    <RichWhisper commentId={commentId} taskId={taskId} whisper={whisper} />
  ) : (
    <PlainWhisper {...rest} />
  );
};
